import Image from "next/image"
import styles from "./tnpsc-group-II-mains-test-series.module.css";
import ImTicon from "../../assets/images/Tnpsc/ImTopIcon-02.png";
import tnpscwebbanner from "../../assets/images/Tnpsc/TNPSC-GR-II&IIA-Prelims-Test-Series-Web-Banner.jpg";
import tnpscMobbanner from "../../assets/images/Tnpsc/TNPSC-GR-II&IIA-Prelims-Test-Series-Mobile-Banner.jpg"
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const  Interest = dynamic(()=>import("../../components/might-be-interest"));
import Head from "next/head";
import Link from "next/link";
const Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper2 = () => {

    const feestructure3 =[
      {center:"Anna Nagar",
        mode: (  <div className="row">
           <div className="col-12 mb-4">
                <div>Batch I (GE+GS - Offline)</div>
              </div>
                <div className="col-12 mb-4">
                <div>Batch I (GE+GS - Online)</div>
              </div>
              <div className="col-12 mb-4">
                <div>Batch II (GT+GS - Offline)</div>
              </div>
               <div className="col-12 mb-4">
                <div>Batch II (GT+GS - Online)</div>
              </div>
            </div>
           ),
        start:( <div className="row">
              <div className="col-12 mb-4">
                <div>24-03-2026</div>
              </div>
              <div className="col-12 mb-4">
                 <div>24-03-2026</div>
              </div>
               <div className="col-12 mb-4">
                <div>25-03-2026</div>
              </div>
              <div className="col-12 mb-4">
                <div>25-03-2026</div>
              </div>
           
            </div>), 
          fee: ( <> <div>₹7,000 (For New students)</div>  <div>₹6,500 (For Old Students)</div>  </>), 
        cont3:(<div className="row">
           
             <div className="col-12  mb-4">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/AnnaNagar/TNPSC-BI-GE-Schedule-AnnaNagar.pdf"
                target="_blank"
                className={`${styles.paybill}`}
              >
                 Click Here (GE)
              </Link>
            </div>
            <div className="col-12  mb-4">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/AnnaNagar/TNPSC-BI-GE-Schedule-AnnaNagar.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click Here (GE)
              </Link>
            </div>
             <div className="col-12  mb-4">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/AnnaNagar/TNPSC-BI-GT-Schedule-AnnaNagar.pdf"
                target="_blank"
                className={`${styles.paybill}`}
              >
                Click Here (GT)
              </Link>
            </div>
            <div className="col-12">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/AnnaNagar/TNPSC-BI-GT-Schedule-AnnaNagar.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click Here (GT)
              </Link>
            </div>
           
          </div>
        ),
       cont4:(<div className="row">
           
            <div className="col-12 mb-2">
             <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
            </div>
            <div className="col-12  mb-2">
             <a href="https://admissionsv1.shankariasacademy.com/?center=ONLINE TEST BATCH&coursetype=TNPSC" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
            </div>
            <div className="col-12 mt-4  mb-2">
             <a href="#" target="_blank"> Admission Closed</a>
            </div>
            <div className="col-12  mb-2">
             {/* <a href="#" target="_blank"> Admission Closed</a> */}
            </div>
              
            
          </div>
        ),
      },

      {center:"Adyar",
        mode: ( <div className="row">
                
                <div className="col-12 mb-md-3">
                  <div className="">Batch I (GE+GS-Offline)</div>
                </div>
                <div className="col-12 mb-2"> 
                  <div className="">Batch I (GT+GS-Offline)</div>
                </div>
              </div>
           ),
        start:<div className="row">
              <div className="col-12 mb-4">
                <div>24-03-2026</div>
              </div>
              <div className="col-12 mb-4">
                 <div>25-03-2026</div>
              </div>
              </div>, 
          fee: ( <> <div>₹7,000 (For New students)</div>  <div>₹6,500 (For Old Students)</div>  </>), 
        cont3:(<div className="row">
            <div className="col-12  mb-2">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Adyar/TNPSC-BI-GE-Schedule-Adyar.pdf"
                target="_blank"
                className={`${styles.paybill}`}
              >
                Click Here (GE)
              </Link>
            </div>
            <div className="col-12">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Adyar/TNPSC-BI-GT-Schedule-Adyar.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click Here (GT)
              </Link>
            </div>
          </div>
        ),
         cont4:(<div className="row">
           
            <div className="col-12">
             <a href="https://admissionsv1.shankariasacademy.com/?center=ADYAR&coursetype=TNPSC" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
            </div>
          </div>
        ),
        
      },

      {center:"Salem",
        
        mode: ( <div className="row">

          <div className="col-12 mb-md-3">
                  <div className="">Batch II (GE+GS-Offline)</div>
                </div>
                <div className="col-12 mb-4"> 
                  <div className="">Batch II (GT+GS-Offline)</div>
                </div>
                
                {/* <div className="col-12 mb-md-3">
                  <div className="">Batch I (GE+GS-Offline)</div>
                </div>
                <div className="col-12 mb-2"> 
                  <div className="">Batch I (GT+GS-Offline)</div>
                </div> */}
              </div>
           ),
        start:(<> <div>12.04.2026</div> </>), 
          fee: ( <> <div>₹6,500 (For New students)</div>  <div>₹6,000 (For Old Students)</div>  </>), 
        cont3:(<div className="row">

                <div className="col-12  mb-2">
                  <Link
                   href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Salem/TNPSC-B2-GE-Schedule-Salem.pdf"
                   target="_blank"
                   className={`${styles.paybill}`}
                  >
                  Click here (B2-GE)
                  </Link>
                </div>
                <div className="col-12 mb-4">
                  <Link
                    href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Salem/TNPSC-B2-GT-Schedule-Salem.pdf"
                    target="_blank"
                    className={`${styles.paybill} `}
                  >
                     Click here (B2-GT)
                  </Link>
                </div>


            {/* <div className="col-12  mb-2">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Salem/TNPSC-BI-GE-Schedule-Salem.pdf"
                target="_blank"
                className={`${styles.paybill}`}
              >
               Click here (GE)
              </Link>
            </div>
            <div className="col-12">
              <Link
                 href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Salem/TNPSC-BI-GT-Schedule-Salem.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click here (GT)
              </Link>
            </div> */}
          </div>
        ),
         cont4:(<div className="row">
           
            <div className="col-12">
             <a href="https://admissionsv1.shankariasacademy.com/?center=SALEM&coursetype=TNPSC" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
            </div>
          </div>
        ),
        
      },
      

      {center:"Madurai",
        mode: ( <div className="row">
                
                <div className="col-12 mb-md-3">
                  <div className="">Batch I (GE+GS-Offline)</div>
                </div>
                <div className="col-12 mb-2"> 
                  <div className="">Batch I  (GT+GS-Offline)</div>
                </div>
              </div>
           ),
        start:"02-04-2026", 
          fee: ( <> <div>₹6,500 (For New students)</div>  <div>₹6,000 (For Old Students)</div>  </>), 
        cont3:(<div className="row">
            <div className="col-12  mb-2">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Madurai/TNPSC-BI-GE-Schedule-Madurai.pdf"
                target="_blank"
                className={`${styles.paybill}`}
              >
                Click here (GE)
              </Link>
            </div>
            <div className="col-12">
              <Link
                 href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Madurai/TNPSC-BI-GT-Schedule-Madurai.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click here (GT)
              </Link>
            </div>
          </div>
        ),
       cont4:(<div className="row">
           
            <div className="col-12 pt-3">
             <a href="#" target="_blank"> Admission Closed</a>
            </div>
          </div>
        ),
      },
      {center:"Namakkal",
        mode: ( <div className="row">
                <div className="col-12 mb-md-3">
                  <div className="">Batch I (GE+GS-Offline)<br/></div>
                </div>
                <div className="col-12 mb-2"> 
                  <div className="">Batch I  (GT+GS-Offline) <br/></div>
                </div>
                
              </div>
           ),
        start:"06-04-2026", 
          fee: ( <> <div>₹6,500 (For New students)</div>  <div>₹6,000 (For Old Students)</div>  </>), 
        cont3:(<div className="row">
            <div className="col-12  mb-2">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Namakkal/TNPSC-BI-GE-Schedule-Namakkal.pdf"
                target="_blank"
                className={`${styles.paybill}`}
              >
                Click here (GE)
              </Link>
            </div>
            <div className="col-12">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Namakkal/TNPSC-BI-GT-Schedule-Namakkal.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click here (GT)
              </Link>
            </div>
          </div>
        ),
       cont4:(<div className="row">
           
            <div className="col-12">
             <a href="https://admissionsv1.shankariasacademy.com/?center=NAMAKKAL&coursetype=TNPSC" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
            </div>
          </div>
        ),
      },
{center:"Trichy",
        mode: ( <div className="row">
                <div className="col-12 mb-md-3">
                  <div className="">Batch I (GE+GS-Offline)<br/></div>
                </div>
                <div className="col-12 mb-2"> 
                  <div className="">Batch I  (GT+GS-Offline) <br/></div>
                </div>
                
              </div>
           ),
        start:"06-04-2026", 
          fee: ( <> <div>₹6,500 (For New students)</div>  <div>₹6,000 (For Old Students)</div>  </>), 
        cont3:(<div className="row">
            <div className="col-12  mb-2">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Trichy/TNPSC-BI-GE-Schedule-Trichy.pdf"
                target="_blank"
                className={`${styles.paybill}`}
              >
                 Click here (GE)
              </Link>
            </div>
            <div className="col-12">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Trichy/TNPSC-BI-GT-Schedule-Trichy.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click here (GT)
              </Link>
            </div>
          </div>
        ),
       cont4:(<div className="row">
           
            <div className="col-12">
             <a href="https://admissionsv1.shankariasacademy.com/?center=NAMAKKAL&coursetype=TNPSC" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
            </div>
          </div>
        ),
      }, 

{center:"Thiruvarur",
        mode: ( <div className="row">
                <div className="col-12 mb-md-3">
                  <div className="">Batch I (GE+GS-Offline)<br/></div>
                </div>
                <div className="col-12 mb-2"> 
                  <div className="">Batch I  (GT+GS-Offline) <br/></div>
                </div>
                
              </div>
           ),
        start:"30-03-2026", 
        fee: ( <> <div>₹6,500 (For New students)</div>  <div>₹6,000 (For Old Students)</div>  </>), 
        cont3:(<div className="row">
            <div className="col-12  mb-2">
              <Link
               href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Thiruvarur/TNPSC-BI-GE-Schedule-Thiruvarur.pdf"
               target="_blank"
               className={`${styles.paybill}`}
              >
                Click here (GE)
              </Link>
            </div>
            <div className="col-12">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Thiruvarur/TNPSC-BI-GT-Schedule-Thiruvarur.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click here (GT)
              </Link>
            </div>
          </div>
        ),
       cont4:(<div className="row">
           
            <div className="col-12">
             <a href="https://admissionsv1.shankariasacademy.com/?center=THIRUVARUR&coursetype=TNPSC" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
            </div>
          </div>
        ),
      },


      {center:"Coimbatore",
        mode: ( <div className="row">
                <div className="col-12 mb-md-3">
                  <div className="">Batch I (GE+GS-Offline)<br/></div>
                </div>
                <div className="col-12 mb-2"> 
                  <div className="">Batch I  (GT+GS-Offline) <br/></div>
                </div>
                
              </div>
           ),
        start:"31-03-2026", 
        fee: ( <> <div>₹6,500 (For New students)</div>  <div>₹6,000 (For Old Students)</div>  </>), 
        cont3:(<div className="row">
            <div className="col-12  mb-2">
              <Link
               href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Covai/TNPSC-BI-GE-Schedule-Covai.pdf"
               target="_blank"
               className={`${styles.paybill}`}
              >
                Click here (GE)
              </Link>
            </div>
            <div className="col-12">
              <Link
                href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRPII-Prelimstest-2026/Covai/TNPSC-BI-GT-Schedule-Covai.pdf"
                target="_blank"
                className={`${styles.paybill} `}
              >
                Click here (GT)
              </Link>
            </div>
          </div>
        ),
       cont4:(<div className="row">
           
            <div className="col-12">
             <a href="https://admissionsv1.shankariasacademy.com/?center=Covai&coursetype=TNPSC" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
            </div>
          </div>
        ),
      },


      // {center:"Trichy",
      //   mode: ( <div className="row">
      //           <div className="col-12 mb-2"> 
      //             <div className="">Batch I  (GT-Offline) </div>
      //           </div>
      //           <div className="col-12 mb-md-3">
      //             <div className="">Batch I (GE-Offline)</div>
      //           </div>
      //         </div>
      //      ),
      //   start:"28-06-2025", 
      //     fee: ( <> <div>₹6,500 (For New students)</div>  <div>₹6,000 (For Old Students)</div>  </>), 
      //   cont3:(<div className="row">
      //       <div className="col-12  mb-2">
      //         <Link
      //           href="https://www.shankariasacademy.com/pdf/Tnpsc-GRP-II-IIA-Prelims-TestSeries-2025/Trichy/GRP-II-&-II-A-Prelims-2025-GT-Batch2-Trichy.pdf"
      //           target="_blank"
      //           className={`${styles.paybill}`}
      //         >
      //           Click here (GT)
      //         </Link>
      //       </div>
      //       <div className="col-12">
      //         <Link
      //           href="https://www.shankariasacademy.com/pdf/Tnpsc-GRP-II-IIA-Prelims-TestSeries-2025/Trichy/GRP-II-&-II-A-Prelims-2025-GE-Batch2-Trichy.pdf"
      //           target="_blank"
      //           className={`${styles.paybill} `}
      //         >
      //           Click here (GE)
      //         </Link>
      //       </div>
      //     </div>
      //   )},
       

    
      

        ]
   
    return (
        <>
        
        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index,follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2026-01-25T05:43:44+00:00" />
            <title>TNPSC Group II/IIA Prelims Test Series 2026</title>
            <meta name="title" content="TNPSC Group II/IIA Prelims Test Series 2026" />
            <meta name="description" content="TNPSC Group II/IIA Prelims Test Series 2026 is here! Practice with real-exam level questions, track your performance, and improve steadily. Join Now! " />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-II-IIA-prelims-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group II/IIA Prelims Test Series 2026" />
            <meta property="og:description" content="TNPSC Group II/IIA Prelims Test Series 2026 is here! Practice with real-exam level questions, track your performance, and improve steadily. Join Now! " />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-II-IIA-prelims-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="tnpsc" />

        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-2 pb-2"> 
                <h1 className={`${styles.pagemaintitle}`}><Image src={ImTicon} width='100' height='100' />TNPSC Group II/IIA Prelims Test Series 2026</h1>
            </div>
            </div>

           <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={tnpscwebbanner}
                alt="Group II/II-A banner"
                title="TNPSC Group II/II-A Test Series 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

          <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={tnpscMobbanner}
                alt="Group II/II-A banner"
                title="TNPSC Group II/II-A Test Series 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

        </div>


        <section  id="courseandfees">
        <div className="container pt-xl-4" >
            <div className="row">
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#073c80" }}>Center</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#073c80" }}>Mode</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#073c80" }}>Starts on</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#073c80" }}>Fee</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#073c80" }}>Schedule</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#073c80" }}>Payment</div>
                <hr/>
            </div>
            
            {feestructure3.map((item,index)=>(
                <div className={`${styles.facultyborder3} row`}>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.center}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Mode</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.mode}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.start}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0 pb-md-2`}>{item.fee}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.cont3}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2 `}>Payment</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-0`}>
                   {item.cont4}
                </div>

                <hr/>

                </div>
            ))} 
            
        </div>
	      </section>	

    <Interest />
    <Footer />

        </>
    )
}

export default Tnpsc_Group2_2A_Mains_2022_New_Test_Series_Paper2
